"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultEndIcon = DefaultEndIcon;
exports["default"] = exports.MenuBase = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _regenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _clsx5 = _interopRequireDefault(require("clsx"));
var _ArrowDownIcon = _interopRequireDefault(require("../../svg/ArrowDownIcon"));
var _ArrowUpIcon = _interopRequireDefault(require("../../svg/ArrowUpIcon"));
var _ArrowRightIcon = _interopRequireDefault(require("../../svg/ArrowRightIcon"));
var _context15 = _interopRequireDefault(require("../Theme/context"));
var _MenuItem = _interopRequireWildcard(require("../MenuItem"));
var _Paper = _interopRequireDefault(require("../Paper"));
var _Popover = _interopRequireDefault(require("../Modal/Popover"));
var _context16 = _interopRequireWildcard(require("../Modal/context"));
var _context17 = _interopRequireDefault(require("./context"));
var _excluded = ["open", "effect", "OpenedStateIcon", "ClosedStateIcon"],
  _excluded2 = ["classNames", "defaultClassName", "menu", "PaperComponent", "PaperProps", "MenuItemComponent", "MenuItemProps", "classes", "storageOpenMenu", "menuKey", "selectable", "multiple", "onChange", "effect", "_type", "_root"],
  _excluded3 = ["value"],
  _excluded4 = ["items", "itemsHeading", "menuType", "menuItemSetActiveWhenOpen", "PopoverProps", "MenuBaseProps", "MenuBaseComponent", "Component", "getListPortalContainer", "beforeOpen", "beforeClose", "onOpen", "onClose", "EndIcon", "EndIconProps", "role", "disableParentRoute", "propsForMenuItemProps"],
  _excluded5 = ["divider", "Component", "menuType", "role", "propsForMenuItemProps", "disableParentRoute", "disableToggleSelect", "onSelectChange", "value"],
  _excluded6 = ["classNames", "PaperProps", "MenuItemProps", "PopoverProps", "classes", "anchorComponentSetActiveWhenOpen", "menu", "_root", "maxFeaturedLength"],
  _excluded7 = ["AnchorComponent", "AnchorComponentProps", "getAnchorElement", "BackdropComponentProps", "popperOptions"],
  _excluded8 = ["role", "featured"],
  _excluded9 = ["featured", "onlyIcon", "featuredMenuItemProps"],
  _excluded0 = ["disableParentRoute", "Component", "featuredMenuItemProps"],
  _excluded1 = ["modal"];
var defaultStyle = require("./../empty_css.js")["default"];
function DefaultEndIcon(props) {
  var open = props.open,
    effect = props.effect,
    _props$OpenedStateIco = props.OpenedStateIcon,
    OpenedStateIcon = _props$OpenedStateIco === void 0 ? _ArrowUpIcon["default"] : _props$OpenedStateIco,
    _props$ClosedStateIco = props.ClosedStateIcon,
    ClosedStateIcon = _props$ClosedStateIco === void 0 ? _ArrowDownIcon["default"] : _props$ClosedStateIco,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(open),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _open = _useState2[0],
    setOpen = _useState2[1];
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setOpen: setOpen
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setOpen: function () {
              var _setOpen = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee() {
                return (0, _regenerator2["default"])().w(function (_context) {
                  while (1) switch (_context.n) {
                    case 0:
                      return _context.a(2);
                  }
                }, _callee);
              }));
              function setOpen() {
                return _setOpen.apply(this, arguments);
              }
              return setOpen;
            }()
          }
        });
      }
    };
  });
  if (_open) {
    return /*#__PURE__*/_react["default"].createElement(OpenedStateIcon, rest);
  }
  return /*#__PURE__*/_react["default"].createElement(ClosedStateIcon, rest);
}
function defaultSort(a, b) {
  var aO = a.order || 0;
  var bO = b.order || 0;
  return aO > bO ? 1 : aO < bO ? -1 : 0;
}
function filterAndApplyMenuItemProps(menu, propsForMenuItemProps, onlyRole) {
  if (menu !== null && menu !== void 0 && menu.length) {
    var filteredMenu = menu.filter(function (m) {
      if (!m.role) {
        return true;
      } else {
        return m.role(m.propsForMenuItemProps || propsForMenuItemProps);
      }
    });
    filteredMenu.forEach(function (m) {
      if (m.items) {
        m.items = filterAndApplyMenuItemProps(m.items, propsForMenuItemProps, onlyRole).sort(defaultSort);
      }
      if (!onlyRole) {
        var keys = ['href', 'label', 'disabled'];
        keys.forEach(function (key) {
          if (typeof m[key] === 'function') {
            m[key] = m[key](m.propsForMenuItemProps || propsForMenuItemProps);
          }
        });
      }
    });
    return filteredMenu;
  }
  return menu;
}
var MenuBase = exports.MenuBase = /*#__PURE__*/_react["default"].forwardRef(function (props, _ref4) {
  var modalContext = (0, _react.useContext)(_context16["default"]);
  var popoverContext = (0, _react.useContext)(_context16.PopoverContext);
  var menuContext = (0, _react.useContext)(_context17["default"]);
  var _useContext = (0, _react.useContext)(_context15["default"]),
    _useContext$additiona = _useContext.additionalStyles,
    additionalStyles = _useContext$additiona === void 0 ? {} : _useContext$additiona,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? additionalStyles.menu || defaultStyle : _props$classNames,
    defaultClassName = props.defaultClassName,
    _props$menu = props.menu,
    menu = _props$menu === void 0 ? [] : _props$menu,
    _props$PaperComponent = props.PaperComponent,
    PaperComponent = _props$PaperComponent === void 0 ? _Paper["default"] : _props$PaperComponent,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    _props$MenuItemCompon = props.MenuItemComponent,
    MenuItemComponent = _props$MenuItemCompon === void 0 ? _MenuItem["default"] : _props$MenuItemCompon,
    _props$MenuItemProps = props.MenuItemProps,
    MenuItemProps = _props$MenuItemProps === void 0 ? {} : _props$MenuItemProps,
    _props$classes = props.classes,
    classes = _props$classes === void 0 ? {} : _props$classes,
    storageOpenMenu = props.storageOpenMenu,
    _props$menuKey = props.menuKey,
    menuKey = _props$menuKey === void 0 ? 'menu' : _props$menuKey,
    _props$selectable = props.selectable,
    selectable = _props$selectable === void 0 ? false : _props$selectable,
    _props$multiple = props.multiple,
    multiple = _props$multiple === void 0 ? false : _props$multiple,
    onChange = props.onChange,
    effect = props.effect,
    _type = props._type,
    _props$_root = props._root,
    _root = _props$_root === void 0 ? true : _props$_root,
    rest3 = (0, _objectWithoutProperties2["default"])(props, _excluded2);
  var _rest3$value = rest3.value,
    value = _rest3$value === void 0 ? [] : _rest3$value,
    rest2 = (0, _objectWithoutProperties2["default"])(rest3, _excluded3);
  value = typeof value === 'object' && value.length ? value : [];
  if (!multiple && value.length) {
    value = [value[0]];
  }
  var _useState3 = (0, _react.useState)(1),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    update = _useState4[0],
    setUpdate = _useState4[1];
  var selectedMenus = (0, _react.useRef)(value);
  var selectableButtons = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    if (JSON.stringify(selectedMenus.current) !== JSON.stringify(value)) {
      selectedMenus.current = value;
      setUpdate(update + 1);
    }
  }, [JSON.stringify(value), JSON.stringify(selectedMenus.current)]);
  var _rest2$emptySelectedM = rest2.emptySelectedMenus,
    emptySelectedMenus = _rest2$emptySelectedM === void 0 ? selectable ? function emptySelectedMenus() {
      selectedMenus.current.splice(0, selectedMenus.current.length);
    } : null : _rest2$emptySelectedM,
    _rest2$addToSelectedM = rest2.addToSelectedMenus,
    addToSelectedMenus = _rest2$addToSelectedM === void 0 ? selectable ? function addToSelectedMenus(value) {
      if (selectedMenus.current.indexOf(value) === -1) {
        if (!multiple) {
          emptySelectedMenus();
          Object.keys(selectableButtons.current).forEach(function (key) {
            if (key !== value.toString()) {
              var elements = selectableButtons.current[key].elements || [];
              elements.forEach(function () {
                var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var actions = p.actions;
                if (actions !== null && actions !== void 0 && actions.setActive) {
                  actions.setActive(false);
                }
              });
            }
          });
        }
        selectedMenus.current.push(value);
      }
    } : null : _rest2$addToSelectedM,
    _rest2$removeFromSele = rest2.removeFromSelectedMenus,
    removeFromSelectedMenus = _rest2$removeFromSele === void 0 ? selectable ? function removeFromSelectedMenus(value) {
      if (selectedMenus.current.indexOf(value) !== -1) {
        var index = selectedMenus.current.indexOf(value);
        selectedMenus.current.splice(index, 1);
      }
    } : null : _rest2$removeFromSele,
    _rest2$isSelected = rest2.isSelected,
    isSelected = _rest2$isSelected === void 0 ? selectable ? function isSelected(value) {
      return selectedMenus.current.indexOf(value) > -1;
    } : null : _rest2$isSelected,
    _rest2$toggleSelect = rest2.toggleSelect,
    toggleSelect = _rest2$toggleSelect === void 0 ? selectable ? (/*#__PURE__*/function () {
      var _toggleSelect = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee2(e, value) {
        return (0, _regenerator2["default"])().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!isSelected(value)) {
                _context2.n = 2;
                break;
              }
              removeFromSelectedMenus(value);
              if (!onChange) {
                _context2.n = 1;
                break;
              }
              _context2.n = 1;
              return onChange(e, selectedMenus.current);
            case 1:
              return _context2.a(2, false);
            case 2:
              addToSelectedMenus(value);
              if (!onChange) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return onChange(e, selectedMenus.current);
            case 3:
              return _context2.a(2, true);
            case 4:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function toggleSelect(_x, _x2) {
        return _toggleSelect.apply(this, arguments);
      }
      return toggleSelect;
    }()) : null : _rest2$toggleSelect,
    _rest2$addToSelectabl = rest2.addToSelectableButtons,
    addToSelectableButtons = _rest2$addToSelectabl === void 0 ? selectable ? function addToSelectableButtons(_value, _ref) {
      var actions = _ref.actions;
      var value = _value.toString();
      if (!selectableButtons.current[value]) {
        selectableButtons.current[value] = {
          elements: []
        };
      }
      var reference = {
        actions: actions,
        value: value
      };
      selectableButtons.current[value].elements.push(reference);
      return function () {
        var index = selectableButtons.current[value].elements.indexOf(reference);
        if (index > -1) {
          selectableButtons.current[value].elements.splice(index, 1);
        }
      };
    } : null : _rest2$addToSelectabl;
  if (classNames !== additionalStyles.menu) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var menuRef = (0, _react.useRef)();
  var isList = _type === 'list';
  var isPopover = _type === 'popover';
  var isBase = !isList && !isPopover;
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          getValue: function getValue() {
            return (0, _toConsumableArray2["default"])(selectedMenus.current);
          }
        }
      });
    }
  });
  var propsForMenuItemProps = _root && menuContext.getPropsForMenuItemProps ? menuContext.getPropsForMenuItemProps() : undefined;
  var filteredMenu = (_root ? filterAndApplyMenuItemProps(menu, propsForMenuItemProps) : menu).sort(defaultSort);
  if (!(filteredMenu !== null && filteredMenu !== void 0 && filteredMenu.length)) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(PaperComponent, Object.assign({
    color: 'paper1',
    size: 'menu',
    ContentComponent: 'Modal'
  }, PaperProps, {
    defaultClassName: (0, _clsx5["default"])(classNames.menu, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, classNames.listPaper, isList), classNames.popoverPaper, isPopover), classNames.basePaper, isBase), PaperProps.defaultClassName, defaultClassName, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, classes.listPaper, classes.listPaper && isList), classes.popoverPaper, classes.popoverPaper && isPopover), classes.basePaper, classes.basePaper && isBase)),
    ref: function ref(e) {
      menuRef.current = e;
      if (_ref4) {
        if (typeof _ref4 === 'function') {
          _ref4(e);
        } else if (_ref4 && typeof _ref4 === 'object') {
          _ref4.current = e;
        }
      }
    }
  }), filteredMenu.map(function (menuProps, i) {
    var _menuProps$items;
    if (menuProps.items && !menuProps.items.length) {
      return null;
    }
    if ((_menuProps$items = menuProps.items) !== null && _menuProps$items !== void 0 && _menuProps$items.length) {
      var items = menuProps.items,
        itemsHeading = menuProps.itemsHeading,
        _menuProps$menuType = menuProps.menuType,
        menuType = _menuProps$menuType === void 0 ? 'list' : _menuProps$menuType,
        menuItemSetActiveWhenOpen = menuProps.menuItemSetActiveWhenOpen,
        _menuProps$PopoverPro = menuProps.PopoverProps,
        PopoverProps = _menuProps$PopoverPro === void 0 ? {} : _menuProps$PopoverPro,
        _menuProps$MenuBasePr = menuProps.MenuBaseProps,
        MenuBaseProps = _menuProps$MenuBasePr === void 0 ? {} : _menuProps$MenuBasePr,
        _menuProps$MenuBaseCo = menuProps.MenuBaseComponent,
        MenuBaseComponent = _menuProps$MenuBaseCo === void 0 ? MenuBase : _menuProps$MenuBaseCo,
        Component = menuProps.Component,
        getListPortalContainer = menuProps.getListPortalContainer,
        beforeOpen = menuProps.beforeOpen,
        beforeClose = menuProps.beforeClose,
        _onOpen = menuProps.onOpen,
        _onClose = menuProps.onClose,
        _menuProps$EndIcon = menuProps.EndIcon,
        EndIcon = _menuProps$EndIcon === void 0 ? DefaultEndIcon : _menuProps$EndIcon,
        _menuProps$EndIconPro = menuProps.EndIconProps,
        EndIconProps = _menuProps$EndIconPro === void 0 ? {} : _menuProps$EndIconPro,
        role = menuProps.role,
        disableParentRoute = menuProps.disableParentRoute,
        _propsForMenuItemProps = menuProps.propsForMenuItemProps,
        restMenuProps = (0, _objectWithoutProperties2["default"])(menuProps, _excluded4);
      var _PopoverProps$popperO = PopoverProps.popperOptions,
        popperOptions = _PopoverProps$popperO === void 0 ? {} : _PopoverProps$popperO;
      var button = {};
      var defaultPaperProps = (0, _objectSpread2["default"])({}, props.DefaultPaperProps ? props.DefaultPaperProps : PaperProps);
      var defaultMenuItemProps = (0, _objectSpread2["default"])({}, props.DefaultMenuItemProps ? props.DefaultMenuItemProps : MenuItemProps);
      var C = Component || MenuItemComponent;
      var changeIconOpenState;
      if (menuType === 'list') {
        var ListMenuBase = function ListMenuBase() {
          var _MenuBaseProps$PaperP2, _MenuBaseProps$MenuIt, _MenuBaseProps$MenuIt2, _MenuBaseProps$MenuIt3;
          return /*#__PURE__*/_react["default"].createElement(MenuBaseComponent, Object.assign({}, props, MenuBaseProps, {
            PaperProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultPaperProps), {}, {
              Component: 'div',
              size: 'none',
              elevation: 0,
              arrow: false
            }, MenuBaseProps.PaperProps ? MenuBaseProps.PaperProps : {}), {}, {
              effect: function effect(p) {
                var _MenuBaseProps$PaperP;
                var actions = p.actions;
                list.actions = actions;
                if (defaultPaperProps.effect) {
                  defaultPaperProps.effect(p);
                }
                if ((_MenuBaseProps$PaperP = MenuBaseProps.PaperProps) !== null && _MenuBaseProps$PaperP !== void 0 && _MenuBaseProps$PaperP.effect) {
                  MenuBaseProps.PaperProps.effect(p);
                }
              },
              className: (0, _clsx5["default"])(defaultPaperProps.className, (_MenuBaseProps$PaperP2 = MenuBaseProps.PaperProps) === null || _MenuBaseProps$PaperP2 === void 0 ? void 0 : _MenuBaseProps$PaperP2.className, (0, _defineProperty2["default"])({}, classNames.listPaperVisible, state.open))
            }),
            MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultMenuItemProps), MenuBaseProps.MenuItemProps ? MenuBaseProps.MenuItemProps : {}), {}, {
              inset: typeof ((_MenuBaseProps$MenuIt = MenuBaseProps.MenuItemProps) === null || _MenuBaseProps$MenuIt === void 0 ? void 0 : _MenuBaseProps$MenuIt.inset) == 'boolean' ? MenuBaseProps.MenuItemProps.inset : typeof defaultMenuItemProps.inset == 'boolean' ? defaultMenuItemProps.inset : true,
              style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultMenuItemProps.style ? defaultMenuItemProps.style : {}), (_MenuBaseProps$MenuIt2 = MenuBaseProps.MenuItemProps) !== null && _MenuBaseProps$MenuIt2 !== void 0 && _MenuBaseProps$MenuIt2.style ? MenuBaseProps.MenuItemProps.style : {}), {}, {
                '--digby-menuitem-inset-multiplier': (_MenuBaseProps$MenuIt3 = MenuBaseProps.MenuItemProps) !== null && _MenuBaseProps$MenuIt3 !== void 0 && _MenuBaseProps$MenuIt3.style && typeof MenuBaseProps.MenuItemProps.style['--digby-menuitem-inset-multiplier'] == 'number' ? MenuBaseProps.MenuItemProps.style['--digby-menuitem-inset-multiplier'] : MenuItemProps.style && typeof MenuItemProps.style['--digby-menuitem-inset-multiplier'] == 'number' ? MenuItemProps.style['--digby-menuitem-inset-multiplier'] + 1 : 1
              })
            }),
            DefaultPaperProps: props.DefaultPaperProps || PaperProps,
            DefaultMenuItemProps: props.DefaultMenuItemProps || MenuItemProps,
            _type: 'list',
            _root: false,
            menu: [].concat((0, _toConsumableArray2["default"])(itemsHeading ? [(0, _objectSpread2["default"])({}, itemsHeading), {
              divider: true
            }] : []), (0, _toConsumableArray2["default"])(menuProps.items)),
            menuKey: menuKey + '_' + i,
            storageOpenMenu: storageOpenMenu
          }, selectable ? {
            selectable: selectable,
            multiple: multiple,
            emptySelectedMenus: emptySelectedMenus,
            addToSelectedMenus: addToSelectedMenus,
            removeFromSelectedMenus: removeFromSelectedMenus,
            isSelected: isSelected,
            toggleSelect: toggleSelect,
            addToSelectableButtons: addToSelectableButtons
          } : {}));
        };
        var _setOpen2 = /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee3(value, e) {
            var _MenuBaseProps$PaperP3, _popoverContext$poppe;
            var br;
            return (0, _regenerator2["default"])().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  br = false;
                  if (!(value && beforeOpen)) {
                    _context3.n = 2;
                    break;
                  }
                  _context3.n = 1;
                  return beforeOpen({
                    state: state,
                    setOpen: _setOpen2,
                    e: e
                  });
                case 1:
                  br = _context3.v;
                case 2:
                  if (!(!value && beforeClose)) {
                    _context3.n = 4;
                    break;
                  }
                  _context3.n = 3;
                  return beforeClose({
                    state: state,
                    setOpen: _setOpen2,
                    e: e
                  });
                case 3:
                  br = _context3.v;
                case 4:
                  if (!br) {
                    _context3.n = 5;
                    break;
                  }
                  return _context3.a(2);
                case 5:
                  state.open = value;
                  if (storageOpenMenu) {
                    storageOpenMenu((0, _defineProperty2["default"])({}, menuKey + '_' + i, state.open), true);
                  }
                  if (!menuItemSetActiveWhenOpen) {
                    _context3.n = 6;
                    break;
                  }
                  _context3.n = 6;
                  return button.actions.setActive(state.open);
                case 6:
                  if (!changeIconOpenState) {
                    _context3.n = 7;
                    break;
                  }
                  _context3.n = 7;
                  return changeIconOpenState(state.open);
                case 7:
                  list.actions.setClassName((0, _clsx5["default"])(defaultPaperProps.className, (_MenuBaseProps$PaperP3 = MenuBaseProps.PaperProps) === null || _MenuBaseProps$PaperP3 === void 0 ? void 0 : _MenuBaseProps$PaperP3.className, (0, _defineProperty2["default"])({}, classNames.listPaperVisible, state.open)));
                  if ((_popoverContext$poppe = popoverContext.popper) !== null && _popoverContext$poppe !== void 0 && _popoverContext$poppe.actions) {
                    popoverContext.popper.actions.update();
                  }
                  if (!(_onOpen && state.open)) {
                    _context3.n = 8;
                    break;
                  }
                  _context3.n = 8;
                  return _onOpen({
                    state: state,
                    setOpen: _setOpen2,
                    toggleOpen: toggleOpen,
                    button: button
                  });
                case 8:
                  if (!(_onClose && !state.open)) {
                    _context3.n = 9;
                    break;
                  }
                  _context3.n = 9;
                  return _onClose({
                    state: state,
                    setOpen: _setOpen2,
                    toggleOpen: toggleOpen,
                    button: button
                  });
                case 9:
                  return _context3.a(2);
              }
            }, _callee3);
          }));
          return function setOpen(_x3, _x4) {
            return _ref2.apply(this, arguments);
          };
        }();
        var toggleOpen = /*#__PURE__*/function () {
          var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee4(e) {
            return (0, _regenerator2["default"])().w(function (_context4) {
              while (1) switch (_context4.n) {
                case 0:
                  _context4.n = 1;
                  return _setOpen2(!state.open, e);
                case 1:
                  return _context4.a(2);
              }
            }, _callee4);
          }));
          return function toggleOpen(_x5) {
            return _ref3.apply(this, arguments);
          };
        }();
        var list = {};
        var state = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, typeof restMenuProps.open === 'boolean' ? {
          open: restMenuProps.open
        } : {}), storageOpenMenu ? {
          open: storageOpenMenu(undefined, true)[menuKey + '_' + i]
        } : {});
        var listMenuBaseChildren = /*#__PURE__*/_react["default"].createElement(ListMenuBase, {
          key: i + '-items'
        });
        var listPortalContainer = getListPortalContainer ? getListPortalContainer() : null;
        var r = [/*#__PURE__*/_react["default"].createElement(C, Object.assign({}, (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          endIcon: /*#__PURE__*/_react["default"].createElement(EndIcon, Object.assign({
            open: state.open
          }, EndIconProps, {
            effect: function effect(p) {
              var actions = p.actions;
              changeIconOpenState = actions.setOpen;
              if (EndIconProps.effect) {
                EndIconProps.effect(p);
              }
            }
          }))
        }, MenuItemProps), {}, {
          onClickBefore: null
        }, restMenuProps), menuContext.parentRoute && restMenuProps.href && !disableParentRoute ? {
          href: menuContext.parentRoute + restMenuProps.href
        } : {}), {}, {
          effect: function effect(p) {
            var actions = p.actions;
            button.actions = actions;
            if (restMenuProps.effect) {
              restMenuProps.effect((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
                menu: {
                  setOpen: _setOpen2,
                  toggleOpen: toggleOpen
                }
              }));
            }
          },
          onClick: function () {
            var _onClick = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee5(e) {
              return (0, _regenerator2["default"])().w(function (_context5) {
                while (1) switch (_context5.n) {
                  case 0:
                    e.preventDefault();
                    e.stopPropagation();
                    _context5.n = 1;
                    return toggleOpen(e);
                  case 1:
                    if (!restMenuProps.onClick) {
                      _context5.n = 2;
                      break;
                    }
                    _context5.n = 2;
                    return restMenuProps.onClick(e);
                  case 2:
                    return _context5.a(2);
                }
              }, _callee5);
            }));
            function onClick(_x6) {
              return _onClick.apply(this, arguments);
            }
            return onClick;
          }()
        }, menuItemSetActiveWhenOpen ? {
          active: state.open
        } : {}), {
          key: i
        })), listPortalContainer ? /*#__PURE__*/(0, _reactDom.createPortal)(listMenuBaseChildren, listPortalContainer) : listMenuBaseChildren];
        setTimeout(function () {
          if (_onOpen && state.open) {
            _onOpen({
              state: state,
              setOpen: _setOpen2,
              toggleOpen: toggleOpen
            });
          }
        });
        return r;
      } else {
        var _PopoverProps$Compone, _popperOptions$modifi, _popperOptions$modifi2;
        return /*#__PURE__*/_react["default"].createElement(Menu, Object.assign({}, props, MenuBaseProps, {
          DefaultPaperProps: props.DefaultPaperProps || PaperProps,
          DefaultMenuItemProps: props.DefaultMenuItemProps || MenuItemProps,
          PaperProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultPaperProps), MenuBaseProps.PaperProps ? MenuBaseProps.PaperProps : {}),
          MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultMenuItemProps), MenuBaseProps.MenuItemProps ? MenuBaseProps.MenuItemProps : {}),
          PopoverProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, PopoverProps), {}, {
            AnchorComponent: MenuItemComponent,
            AnchorComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
              endIcon: /*#__PURE__*/_react["default"].createElement(EndIcon, Object.assign({
                OpenedStateIcon: _ArrowRightIcon["default"]
              }, EndIconProps, {
                effect: function effect(p) {
                  var actions = p.actions;
                  changeIconOpenState = actions.setOpen;
                  if (EndIconProps.effect) {
                    EndIconProps.effect(p);
                  }
                }
              }))
            }, MenuItemProps), {}, {
              onClickBefore: null
            }, restMenuProps), {}, {
              effect: function effect() {
                var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var actions = p.actions;
                button.actions = actions;
                if (restMenuProps.effect) {
                  restMenuProps.effect(p);
                }
              },
              onClick: function () {
                var _onClick2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee6(e) {
                  return (0, _regenerator2["default"])().w(function (_context6) {
                    while (1) switch (_context6.n) {
                      case 0:
                        if (!restMenuProps.onClick) {
                          _context6.n = 1;
                          break;
                        }
                        _context6.n = 1;
                        return restMenuProps.onClick(e);
                      case 1:
                        return _context6.a(2);
                    }
                  }, _callee6);
                }));
                function onClick(_x7) {
                  return _onClick2.apply(this, arguments);
                }
                return onClick;
              }()
            }),
            ComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, PopoverProps.ComponentProps ? PopoverProps.ComponentProps : {}), {}, {
              className: (0, _clsx5["default"])(classNames.modalPortedBackdrop, (_PopoverProps$Compone = PopoverProps.ComponentProps) === null || _PopoverProps$Compone === void 0 ? void 0 : _PopoverProps$Compone.className)
            }),
            BackdropComponent: function BackdropComponent(props) {
              if (!menuRef.current || !modalContext.portalElement) {
                return /*#__PURE__*/_react["default"].createElement("div", props);
              }
              return /*#__PURE__*/(0, _reactDom.createPortal)(/*#__PURE__*/_react["default"].createElement("div", props), menuRef.current);
            },
            BackdropComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, PopoverProps.BackdropComponentProps ? PopoverProps.BackdropComponentProps : {}), {}, {
              onClick: function () {
                var _onClick3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee7(e) {
                  var _PopoverProps$Backdro;
                  return (0, _regenerator2["default"])().w(function (_context7) {
                    while (1) switch (_context7.n) {
                      case 0:
                        if (!((_PopoverProps$Backdro = PopoverProps.BackdropComponentProps) !== null && _PopoverProps$Backdro !== void 0 && _PopoverProps$Backdro.onClick)) {
                          _context7.n = 1;
                          break;
                        }
                        _context7.n = 1;
                        return PopoverProps.BackdropComponentProps.onClick(e);
                      case 1:
                        return _context7.a(2);
                    }
                  }, _callee7);
                }));
                function onClick(_x8) {
                  return _onClick3.apply(this, arguments);
                }
                return onClick;
              }()
            }),
            popperOptions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
              placement: 'right-start'
            }, popperOptions), {}, {
              modifiers: [].concat((0, _toConsumableArray2["default"])((_popperOptions$modifi = popperOptions.modifiers) !== null && _popperOptions$modifi !== void 0 && _popperOptions$modifi.find(function (m) {
                return m.name === 'offset';
              }) ? [popperOptions.modifiers.find(function (m) {
                return m.name === 'offset';
              })] : [{
                name: 'offset',
                options: {
                  offset: [0, 8]
                }
              }]), (0, _toConsumableArray2["default"])((_popperOptions$modifi2 = popperOptions.modifiers) !== null && _popperOptions$modifi2 !== void 0 && _popperOptions$modifi2.find(function (m) {
                return m.name === 'flip';
              }) ? [popperOptions.modifiers.find(function (m) {
                return m.name === 'flip';
              })] : [{
                name: 'flip',
                options: {
                  fallbackPlacements: ['bottom', 'left-start', 'top']
                }
              }]), (0, _toConsumableArray2["default"])(popperOptions.modifiers ? popperOptions.modifiers.filter(function (m) {
                return m.name !== 'offset' && m.name !== 'flip';
              }) : []))
            }),
            beforeOpen: beforeOpen,
            beforeClose: beforeClose,
            onOpen: function () {
              var _onOpen2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee8() {
                return (0, _regenerator2["default"])().w(function (_context8) {
                  while (1) switch (_context8.n) {
                    case 0:
                      if (!menuItemSetActiveWhenOpen) {
                        _context8.n = 1;
                        break;
                      }
                      _context8.n = 1;
                      return button.actions.setActive(true);
                    case 1:
                      if (!changeIconOpenState) {
                        _context8.n = 2;
                        break;
                      }
                      _context8.n = 2;
                      return changeIconOpenState(true);
                    case 2:
                      if (!_onOpen) {
                        _context8.n = 3;
                        break;
                      }
                      _context8.n = 3;
                      return _onOpen({
                        button: button
                      });
                    case 3:
                      return _context8.a(2);
                  }
                }, _callee8);
              }));
              function onOpen() {
                return _onOpen2.apply(this, arguments);
              }
              return onOpen;
            }(),
            onClose: function () {
              var _onClose2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee9() {
                return (0, _regenerator2["default"])().w(function (_context9) {
                  while (1) switch (_context9.n) {
                    case 0:
                      if (!menuItemSetActiveWhenOpen) {
                        _context9.n = 1;
                        break;
                      }
                      _context9.n = 1;
                      return button.actions.setActive(false);
                    case 1:
                      if (!changeIconOpenState) {
                        _context9.n = 2;
                        break;
                      }
                      _context9.n = 2;
                      return changeIconOpenState(false);
                    case 2:
                      if (!_onClose) {
                        _context9.n = 3;
                        break;
                      }
                      _context9.n = 3;
                      return _onClose({
                        button: button
                      });
                    case 3:
                      return _context9.a(2);
                  }
                }, _callee9);
              }));
              function onClose() {
                return _onClose2.apply(this, arguments);
              }
              return onClose;
            }()
          }),
          menu: [].concat((0, _toConsumableArray2["default"])(itemsHeading ? [(0, _objectSpread2["default"])({}, itemsHeading), {
            divider: true
          }] : []), (0, _toConsumableArray2["default"])(menuProps.items)),
          key: i,
          menuKey: menuKey + '_' + i,
          storageOpenMenu: storageOpenMenu,
          _root: false
        }));
      }
    } else {
      var divider = menuProps.divider,
        _Component = menuProps.Component,
        _menuType = menuProps.menuType,
        _role = menuProps.role,
        _propsForMenuItemProps2 = menuProps.propsForMenuItemProps,
        _disableParentRoute = menuProps.disableParentRoute,
        disableToggleSelect = menuProps.disableToggleSelect,
        onSelectChange = menuProps.onSelectChange,
        _value2 = menuProps.value,
        _restMenuProps = (0, _objectWithoutProperties2["default"])(menuProps, _excluded5);
      var _C = _Component || MenuItemComponent;
      var mP = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, MenuItemProps), _restMenuProps);
      var active = menuContext.isActive ? menuContext.isActive((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, mP), menuContext.parentRoute && mP.href && !_disableParentRoute ? {
        href: menuContext.parentRoute + mP.href
      } : {})) : mP.active;
      if (selectable && typeof _value2 !== 'undefined') {
        active = isSelected(_value2);
      }
      var _button = {};
      var removeFromSelectableButtons;
      if (divider) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem.Divider, Object.assign({}, _restMenuProps, {
          className: (0, _clsx5["default"])(classNames.divider, _restMenuProps.className),
          key: i
        }));
      } else {
        return /*#__PURE__*/_react["default"].createElement(_C, Object.assign({}, mP, menuContext.parentRoute && mP.href && !_disableParentRoute ? {
          href: menuContext.parentRoute + mP.href
        } : {}, selectable && typeof _value2 !== 'undefined' ? {
          onClickBefore: function () {
            var _onClickBefore = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee0(e) {
              var disable;
              return (0, _regenerator2["default"])().w(function (_context0) {
                while (1) switch (_context0.n) {
                  case 0:
                    disable = typeof disableToggleSelect === 'boolean' ? disableToggleSelect : typeof disableToggleSelect === 'function' ? disableToggleSelect(e, mP) : false;
                    if (disable) {
                      _context0.n = 1;
                      break;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    _context0.n = 2;
                    break;
                  case 1:
                    if (!mP.onClickBefore) {
                      _context0.n = 2;
                      break;
                    }
                    _context0.n = 2;
                    return mP.onClickBefore(e);
                  case 2:
                    return _context0.a(2);
                }
              }, _callee0);
            }));
            function onClickBefore(_x9) {
              return _onClickBefore.apply(this, arguments);
            }
            return onClickBefore;
          }(),
          onClick: function () {
            var _onClick4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee1(e, props) {
              var disable, _button$current, _button$current$actio, selected;
              return (0, _regenerator2["default"])().w(function (_context1) {
                while (1) switch (_context1.n) {
                  case 0:
                    disable = typeof disableToggleSelect === 'boolean' ? disableToggleSelect : typeof disableToggleSelect === 'function' ? disableToggleSelect(e, mP) : false;
                    if (disable) {
                      _context1.n = 5;
                      break;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    if (!mP.disabled) {
                      _context1.n = 1;
                      break;
                    }
                    return _context1.a(2);
                  case 1:
                    _context1.n = 2;
                    return toggleSelect(e, _value2);
                  case 2:
                    selected = _context1.v;
                    if (!((_button$current = _button.current) !== null && _button$current !== void 0 && (_button$current$actio = _button$current.actions) !== null && _button$current$actio !== void 0 && _button$current$actio.setActive)) {
                      _context1.n = 3;
                      break;
                    }
                    _context1.n = 3;
                    return _button.current.actions.setActive(selected);
                  case 3:
                    if (!onSelectChange) {
                      _context1.n = 4;
                      break;
                    }
                    _context1.n = 4;
                    return onSelectChange({
                      button: _button,
                      selected: selected,
                      value: _value2
                    });
                  case 4:
                    _context1.n = 6;
                    break;
                  case 5:
                    if (!mP.onClick) {
                      _context1.n = 6;
                      break;
                    }
                    _context1.n = 6;
                    return mP.onClick(e, props);
                  case 6:
                    return _context1.a(2);
                }
              }, _callee1);
            }));
            function onClick(_x0, _x1) {
              return _onClick4.apply(this, arguments);
            }
            return onClick;
          }(),
          effect: function effect(p) {
            _button.current = p;
            if (p.mounted) {
              removeFromSelectableButtons = addToSelectableButtons(_value2, {
                actions: p.actions
              });
            } else {
              if (removeFromSelectableButtons) {
                removeFromSelectableButtons();
              }
            }
            if (mP.effect) {
              mP.effect(p);
            }
          }
        } : {}, {
          active: active,
          key: i
        }));
      }
    }
  }));
});
function ParentIfFeatured(_ref5) {
  var featuredMenus = _ref5.featuredMenus,
    children = _ref5.children,
    className = _ref5.className;
  if (featuredMenus.length) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: className
    }, children);
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
}
var Menu = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _popperOptions$modifi3, _popperOptions$modifi4, _popoverRest$Componen;
  var menuContext = (0, _react.useContext)(_context17["default"]);
  var _useContext2 = (0, _react.useContext)(_context15["default"]),
    _useContext2$addition = _useContext2.additionalStyles,
    additionalStyles = _useContext2$addition === void 0 ? {} : _useContext2$addition,
    useStyle = _useContext2.useStyle;
  var _props$classNames2 = props.classNames,
    classNames = _props$classNames2 === void 0 ? additionalStyles.menu || defaultStyle : _props$classNames2,
    _props$PaperProps2 = props.PaperProps,
    PaperProps = _props$PaperProps2 === void 0 ? {} : _props$PaperProps2,
    MenuItemProps = props.MenuItemProps,
    _props$PopoverProps = props.PopoverProps,
    PopoverProps = _props$PopoverProps === void 0 ? {} : _props$PopoverProps,
    _props$classes2 = props.classes,
    classes = _props$classes2 === void 0 ? {} : _props$classes2,
    anchorComponentSetActiveWhenOpen = props.anchorComponentSetActiveWhenOpen,
    menu = props.menu,
    _props$_root2 = props._root,
    _root = _props$_root2 === void 0 ? true : _props$_root2,
    maxFeaturedLength = props.maxFeaturedLength,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded6);
  var AnchorComponent = PopoverProps.AnchorComponent,
    _PopoverProps$AnchorC = PopoverProps.AnchorComponentProps,
    AnchorComponentProps = _PopoverProps$AnchorC === void 0 ? {} : _PopoverProps$AnchorC,
    getAnchorElement = PopoverProps.getAnchorElement,
    _PopoverProps$Backdro2 = PopoverProps.BackdropComponentProps,
    BackdropComponentProps = _PopoverProps$Backdro2 === void 0 ? {} : _PopoverProps$Backdro2,
    _PopoverProps$popperO2 = PopoverProps.popperOptions,
    popperOptions = _PopoverProps$popperO2 === void 0 ? {} : _PopoverProps$popperO2,
    popoverRest = (0, _objectWithoutProperties2["default"])(PopoverProps, _excluded7);
  if (classNames !== additionalStyles.menu) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  var modalRef = (0, _react.useRef)();
  var button = (0, _react.useRef)();
  var isMenuBase = !(AnchorComponent || getAnchorElement);
  var featuredMenus = _root ? (0, _toConsumableArray2["default"])(menu.filter(function (menu) {
    return !!(menu.featured && !isMenuBase);
  })) : [];
  if (featuredMenus.length) {
    var propsForMenuItemProps = _root && menuContext.getPropsForMenuItemProps ? menuContext.getPropsForMenuItemProps() : undefined;
    featuredMenus = filterAndApplyMenuItemProps(featuredMenus, propsForMenuItemProps).sort(defaultSort);
    if (typeof maxFeaturedLength === 'number' && maxFeaturedLength >= 0) {
      featuredMenus = featuredMenus.slice(0, maxFeaturedLength);
    }
  }
  var moreMenus = _root ? (0, _toConsumableArray2["default"])(menu.filter(function (menu) {
    return featuredMenus.indexOf(menu) === -1;
  })) : menu;
  if (moreMenus.length) {
    var _moreMenus$0$items;
    var _propsForMenuItemProps3 = _root && menuContext.getPropsForMenuItemProps ? menuContext.getPropsForMenuItemProps() : undefined;
    moreMenus = (_root ? filterAndApplyMenuItemProps(moreMenus, _propsForMenuItemProps3, true) : moreMenus).sort(defaultSort);
    if (_root && moreMenus.length === 1 && !((_moreMenus$0$items = moreMenus[0].items) !== null && _moreMenus$0$items !== void 0 && _moreMenus$0$items.length) && moreMenus[0].featured) {
      featuredMenus.push(moreMenus[0]);
      moreMenus = [];
    }
  }
  featuredMenus = featuredMenus.map(function (_ref6) {
    var role = _ref6.role,
      featured = _ref6.featured,
      m = (0, _objectWithoutProperties2["default"])(_ref6, _excluded8);
    return (0, _objectSpread2["default"])({}, m);
  });
  moreMenus = moreMenus.map(function (_ref7) {
    var featured = _ref7.featured,
      onlyIcon = _ref7.onlyIcon,
      featuredMenuItemProps = _ref7.featuredMenuItemProps,
      m = (0, _objectWithoutProperties2["default"])(_ref7, _excluded9);
    return (0, _objectSpread2["default"])({}, m);
  });
  if (!moreMenus.length && !featuredMenus.length && !isMenuBase) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isMenuBase ? /*#__PURE__*/_react["default"].createElement(ParentIfFeatured, {
    featuredMenus: featuredMenus,
    className: classNames.featuredParent
  }, featuredMenus.length ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, featuredMenus.map(function (p, i) {
    var props = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), p.featuredMenuItemProps ? p.featuredMenuItemProps : {});
    var disableParentRoute = props.disableParentRoute,
      Component = props.Component,
      _props$featuredMenuIt = props.featuredMenuItemProps,
      featuredMenuItemProps = _props$featuredMenuIt === void 0 ? {} : _props$featuredMenuIt,
      menuProps = (0, _objectWithoutProperties2["default"])(props, _excluded0);
    var mP = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, MenuItemProps ? MenuItemProps : {}), menuProps);
    var active = menuContext.isActive ? menuContext.isActive((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, mP), menuContext.parentRoute && mP.href && !disableParentRoute ? {
      href: menuContext.parentRoute + mP.href
    } : {})) : mP.active;
    var C = Component || _MenuItem["default"];
    return /*#__PURE__*/_react["default"].createElement(C, Object.assign({
      key: i
    }, mP, menuContext.parentRoute && mP.href && !disableParentRoute ? {
      href: menuContext.parentRoute + mP.href
    } : {}, {
      active: active
    }));
  })) : null, moreMenus.length ? /*#__PURE__*/_react["default"].createElement(_Popover["default"], Object.assign({}, popoverRest, {
    AnchorComponent: AnchorComponent,
    AnchorComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, AnchorComponentProps), {}, {
      effect: function effect(e) {
        button.current = e;
        if (AnchorComponentProps.effect) {
          AnchorComponentProps.effect(e);
        }
      },
      onClick: function () {
        var _onClick5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee10(e) {
          var _modalRef$actions;
          return (0, _regenerator2["default"])().w(function (_context10) {
            while (1) switch (_context10.n) {
              case 0:
                e.stopPropagation();
                e.preventDefault();
                _context10.n = 1;
                return (_modalRef$actions = modalRef.actions) === null || _modalRef$actions === void 0 ? void 0 : _modalRef$actions.toggleOpen();
              case 1:
                if (!AnchorComponentProps.onClick) {
                  _context10.n = 2;
                  break;
                }
                _context10.n = 2;
                return AnchorComponentProps.onClick(e);
              case 2:
                return _context10.a(2);
            }
          }, _callee10);
        }));
        function onClick(_x10) {
          return _onClick5.apply(this, arguments);
        }
        return onClick;
      }()
    }),
    onOpen: /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee11() {
      var _button$current2, _button$current2$acti;
      var _args11 = arguments;
      return (0, _regenerator2["default"])().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            if (!(anchorComponentSetActiveWhenOpen && (_button$current2 = button.current) !== null && _button$current2 !== void 0 && (_button$current2$acti = _button$current2.actions) !== null && _button$current2$acti !== void 0 && _button$current2$acti.setActive)) {
              _context11.n = 1;
              break;
            }
            _context11.n = 1;
            return button.current.actions.setActive(true);
          case 1:
            if (!popoverRest.onOpen) {
              _context11.n = 2;
              break;
            }
            _context11.n = 2;
            return popoverRest.onOpen.apply(popoverRest, _args11);
          case 2:
            return _context11.a(2);
        }
      }, _callee11);
    })),
    onClose: /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee12() {
      var _button$current3, _button$current3$acti;
      var _args12 = arguments;
      return (0, _regenerator2["default"])().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            if (!(anchorComponentSetActiveWhenOpen && (_button$current3 = button.current) !== null && _button$current3 !== void 0 && (_button$current3$acti = _button$current3.actions) !== null && _button$current3$acti !== void 0 && _button$current3$acti.setActive)) {
              _context12.n = 1;
              break;
            }
            _context12.n = 1;
            return button.current.actions.setActive(false);
          case 1:
            if (!popoverRest.onClose) {
              _context12.n = 2;
              break;
            }
            _context12.n = 2;
            return popoverRest.onClose.apply(popoverRest, _args12);
          case 2:
            return _context12.a(2);
        }
      }, _callee12);
    })),
    getAnchorElement: getAnchorElement,
    BackdropComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, BackdropComponentProps), {}, {
      onClick: function () {
        var _onClick6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee13(e) {
          return (0, _regenerator2["default"])().w(function (_context13) {
            while (1) switch (_context13.n) {
              case 0:
                _context13.n = 1;
                return modalRef.actions.toggleOpen();
              case 1:
                if (BackdropComponentProps.onClick) {
                  BackdropComponentProps.onClick(e);
                }
              case 2:
                return _context13.a(2);
            }
          }, _callee13);
        }));
        function onClick(_x11) {
          return _onClick6.apply(this, arguments);
        }
        return onClick;
      }()
    }),
    effect: function effect(_ref0) {
      var modal = _ref0.modal,
        rest = (0, _objectWithoutProperties2["default"])(_ref0, _excluded1);
      modalRef.actions = modal.actions;
      if (popoverRest.effect) {
        popoverRest.effect((0, _objectSpread2["default"])({
          modal: modal
        }, rest));
      }
    },
    popperOptions: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      placement: 'bottom-start'
    }, popperOptions), {}, {
      modifiers: [].concat((0, _toConsumableArray2["default"])((_popperOptions$modifi3 = popperOptions.modifiers) !== null && _popperOptions$modifi3 !== void 0 && _popperOptions$modifi3.find(function (m) {
        return m.name === 'offset';
      }) ? [popperOptions.modifiers.find(function (m) {
        return m.name === 'offset';
      })] : [{
        name: 'offset',
        options: {
          offset: [0, 8]
        }
      }]), (0, _toConsumableArray2["default"])((_popperOptions$modifi4 = popperOptions.modifiers) !== null && _popperOptions$modifi4 !== void 0 && _popperOptions$modifi4.find(function (m) {
        return m.name === 'flip';
      }) ? [popperOptions.modifiers.find(function (m) {
        return m.name === 'flip';
      })] : [{
        name: 'flip',
        options: {
          fallbackPlacements: ['top', 'right', 'left']
        }
      }]), (0, _toConsumableArray2["default"])(popperOptions.modifiers ? popperOptions.modifiers.filter(function (m) {
        return m.name !== 'offset' && m.name !== 'flip';
      }) : []))
    }),
    ComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, popoverRest.ComponentProps ? popoverRest.ComponentProps : {}), {}, {
      className: (0, _clsx5["default"])(classNames.modal, (_popoverRest$Componen = popoverRest.ComponentProps) === null || _popoverRest$Componen === void 0 ? void 0 : _popoverRest$Componen.className, classes.modal)
    })
  }), /*#__PURE__*/_react["default"].createElement(MenuBase, Object.assign({
    ref: ref
  }, rest, {
    menu: moreMenus,
    PaperProps: (0, _objectSpread2["default"])({
      arrow: true
    }, PaperProps),
    MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, MenuItemProps ? MenuItemProps : {}), {}, {
      onClickBefore: function () {
        var _onClickBefore2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regenerator2["default"])().m(function _callee14(e) {
          return (0, _regenerator2["default"])().w(function (_context14) {
            while (1) switch (_context14.n) {
              case 0:
                if (!modalRef.actions) {
                  _context14.n = 1;
                  break;
                }
                _context14.n = 1;
                return modalRef.actions.setOpen(false);
              case 1:
                if (!(MenuItemProps !== null && MenuItemProps !== void 0 && MenuItemProps.onClickBefore)) {
                  _context14.n = 2;
                  break;
                }
                _context14.n = 2;
                return MenuItemProps.onClickBefore(e);
              case 2:
                return _context14.a(2);
            }
          }, _callee14);
        }));
        function onClickBefore(_x12) {
          return _onClickBefore2.apply(this, arguments);
        }
        return onClickBefore;
      }()
    }),
    classes: classes,
    _type: 'popover',
    _root: _root
  }))) : null) : /*#__PURE__*/_react["default"].createElement(MenuBase, Object.assign({
    ref: ref
  }, rest, {
    menu: menu,
    PaperProps: PaperProps,
    MenuItemProps: MenuItemProps,
    classes: classes,
    _root: _root
  })));
});
var _default = exports["default"] = Menu;